import type { Board } from '../../types';
import type { BoardState } from './types';

/**
 * Helper function to update a board in both currentBoard and boards list
 */
export const updateBoardInState = (state: BoardState, id: string, updated: Board) => ({
  currentBoard: state.currentBoard?.id === id ? updated : state.currentBoard,
  boards: state.boards.map((b) => (b.id === id ? updated : b)),
});
